// Screen 1 — choose which Home Drive host (PC) to open.
import type { PCInfo } from '../api';
import { APP_NAME } from '../branding';

export interface DrivePickerProps {
  pcs: PCInfo[];
  onSelect: (pc: PCInfo) => void;
}

export function DrivePicker({ pcs, onSelect }: DrivePickerProps): JSX.Element {
  return (
    <div className="drive-screen">
      <div className="drive-screen-head">
        <h2 className="drive-screen-title">My Drives</h2>
        <p className="drive-screen-sub">
          Each host is a PC running {APP_NAME}. Pick one to browse its shared folders.
        </p>
      </div>
      {pcs.length === 0 ? (
        <div className="drive-empty">
          <p>No drives found.</p>
          <p className="hint">Install the desktop host on a PC and sign in with this account.</p>
        </div>
      ) : (
        <ul className="drive-host-list">
          {pcs.map((pc) => (
            <li key={pc.id}>
              <button type="button" className="drive-host-card" onClick={() => onSelect(pc)}>
                <span className="drive-host-icon" aria-hidden>
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M4 6h16v12H4V6z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      fill="#e8f0fe"
                    />
                    <path d="M4 8l3-2h10l3 2" stroke="currentColor" strokeWidth="1.5" />
                    <rect x="7" y="11" width="10" height="5" rx="0.5" fill="#1a73e8" opacity="0.25" />
                  </svg>
                </span>
                <span className="drive-host-body">
                  <span className="drive-host-name">{pc.name}</span>
                  <span className="drive-host-meta">{pc.ownerEmail}</span>
                  <span className="drive-host-folders">
                    {pc.folders.length === 0
                      ? 'No shared folders yet'
                      : pc.folders.length === 1
                        ? pc.folders[0].name
                        : `${pc.folders.length} shared folders`}
                  </span>
                </span>
                <span className="drive-host-chevron" aria-hidden>›</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
